<template>
    <v-sheet style="background-color:#fff;height:100%">
        <v-toolbar floating elevation="0" style="border-bottom:1px solid #ddd" pb-5>
            <v-toolbar-title>Meus Pedidos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items></v-toolbar-items>
        </v-toolbar>

        <v-layout wrap style="height:100%">
            <v-container fill-height v-if="load_feito && orders.length == 0">
                <v-flex xs12>
                    <v-layout text-center align-center justify-center>
                        <v-flex xs12>
                            <h1 class="display-1 mb-5">
                                
                                <span class="font-weight-bold">Nada</span> por enquanto
                            </h1>
                            <p
                                class="subheading font-weight-regular my-5"
                            >Aqui ficam listados os seus pedidos e as informações de pagamento.</p>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-container>

            <v-flex xs12 px-3 py-5 v-if="load_feito && orders.length > 0">
                <v-layout>
                    <v-flex xs12>
                        <v-card elevation="0">
                            
                            <v-data-table
                                :headers="headers"
                                :items="orders"
                                no-results-text="Sem resultados para essa busca"
                                text
                                   show-expand

                            >
                            <!-- show-expand-->
                                <template v-slot:item.total="{item}">{{formatarDinheiro(item.total)}}</template>
                                <template v-slot:item.total_payed="{item}">{{formatarDinheiro(item.total_payed)}}</template>
                                <template v-slot:item.status="{item}">{{item.status}}</template>
                                <template v-slot:item.created_at="{item}">
                                    {{
                                        item.created_at.split(" ")[0].split("-").reverse().join("/")
                                    }}
                                </template>
                                
                                <template v-slot:expanded-item="{ headers,item }">
                                    <td :colspan="headers.length" elevation="0">
                                             <v-simple-table class="my-5">
                                                    <thead>
                                                    <tr>
                                                        <th class="text-left">Item</th>
                                                        <th class="text-left">Quantidade</th>
                                                        <th class="text-left">Valor Unitário</th>
                                                        <th class="text-left">Valor Total</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="item in item.items" :key="item.id">
                                                        <td>{{ item.service_slug }}</td>
                                                        <td class="text-left">{{ item.qty }}</td>
                                                        <td>{{ formatarDinheiro(item.unit_price) }}</td>
                                                        <td>{{ formatarDinheiro(item.total) }}</td>
                                                    </tr>
                                                    </tbody>
                                                </v-simple-table>
                                      
                                       
                                    </td>
                                </template>

                                <!--template v-slot:item.action="{ item }">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="primary" dark v-on="on" icon>
                                                <v-icon>more_vert</v-icon>
                                                
                                            </v-btn>
                                        </template>
                                        <v-list dense>
                                            <v-list-item
                                                :to="{name:'work_edit',params:{id:item.id}}"
                                            >
                                                <v-list-item-title>Editar</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-title>Deletar</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template-->
                                <template v-slot:no-data>
                                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-sheet>
</template>

<script>
import PaymentService from "../../../app/Rest/payment";
import { money } from "../../../app/general";

var paymentService = null;
var _money = new money();

export default {
    data: () => ({
        orders: [],
        load_feito: false,
        search: "",
        headers: [
            {
                text: "#ID do Pedido",
                align: "left",
                sortable: true,
                value: "id"
            },
            { text: "Nome do Produto", value: "product_name" },
            { text: "Status", value: "status" },
            { text: "Data Criação", value: "created_at" },
            { text: "Total", value: "total" },
            { text: "Total Pago", value: "total_payed" },
           // { text: "Ações", value: "action", sortable: false }
        ]
    }),
    beforeCreate() {
        this.$vuetify.dataTable = { sortByText: "Ordenar por" };
    },
    mounted() {
        this.$store.commit("loading");
        paymentService = PaymentService.build();
        paymentService
            .getMyOrders()
            .then(e => {
                this.orders = e.items;
                console.log(this.orders);
            })
            .finally(() => {
                this.load_feito = true;
                this.$store.commit("loading", false);
            });
    },
    methods:{
        formatarDinheiro(valor) {
            return _money.formatWithCurrency(valor / 100, 2, ",");
        }
    }
};
</script>
